import React from 'react'
import TextInput from './../../UIComponents/Components/TextInput'

export default class Header extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    render() {
        let { onLeft, title, tempText, isShowHeaderBar, isShowSearchBar, RouterSearch, isShowArrow, className } = this.props
        let GLOBAL = global || window
        return <div className='headerContainer'>
            {
                // GLOBAL?.navigator?.userAgent?.indexOf('iPhone') > 0 && GLOBAL?.screen?.height >= 812 && GLOBAL?.devicePixelRatio >= 2 && localStorage?.getItem("fromApp") &&
                // <div className='headerBox1' style={{ background: isShowHeaderBar ? '#00A6FF' : 'transparent' }}></div>
            }
            {
                isShowHeaderBar &&
                <div className={`headerBox`}>
                    <div className={`arrowIcon leftArrow ${className}`} onClick={onLeft}></div>
                    <div className="headerTitle">{title}</div>
                    <div className="leftArrow leftArrow1"></div>
                </div>
            }

            {
                isShowSearchBar &&
                <div className='searchHeaderBox' style={{ boxShadow: isShowHeaderBar ? 'none' : '0 10px 15px rgba(0, 0, 0, 0.3)' }}>
                    {
                        isShowArrow &&
                        <div
                            onClick={() => {
                                onLeft('QuestionDetail/isBackPage')
                            }}
                            className="arrowIcon" />
                    }
                    <TextInput
                        tempText={tempText}
                        onClick={() => {
                            RouterSearch('Search/QuestionDetail')
                        }}>
                    </TextInput>
                </div>
            }
        </div>
    }
}